import { Link, useParams } from "react-router-dom";
import { useQuery } from "urql";

import { PageHeader } from "@/components/PageHeader";
import { convertGraphQLToForm } from "@/components/forms/TournamentSeriesForm";
import { Button } from "@/components/ui/button";
import { graphql } from "@/gen";

import { AddTournamentSeriesTournaments } from "./AddTournamentSeriesTournaments";
import { TournamentSeriesCalculatedStandings } from "./TournamentSeriesCalculatedStandings";
import { TournamentSeriesStandings } from "./TournamentSeriesStandings";
import { TournamentSeriesTournamentList } from "./TournamentSeriesTournamentList";

const tournamentSeriesDetailQuery = graphql(`
    query TournamentSeriesDetail($id: UUID!) {
        tournamentSeries(id: $id) {
            id
            title
            description
            startAt
            endAt
            standingsCalculation
        }
    }
`);

export default function TournamentSeriesDetailRoute() {
    const { id } = useParams<{ id: string }>();

    const [result] = useQuery({
        query: tournamentSeriesDetailQuery,
        variables: { id: id! },
        pause: !id,
    });

    const series = result.data?.tournamentSeries;
    const standingsCalculation = convertGraphQLToForm(series?.standingsCalculation);
    if (!series) return <div>Tournament series not found.</div>;

    // Check if standings are calculated or manual
    const isManualStandings = !standingsCalculation || standingsCalculation?.type === "manual";

    return (
        <div className="m-4 flex flex-col gap-4">
            <PageHeader
                title={series.title}
                actions={
                    <Button asChild>
                        <Link to={`/tournament-series/${series.id}/edit`}>
                            Edit tournament series
                        </Link>
                    </Button>
                }
            />
            <AddTournamentSeriesTournaments seriesId={series.id} />
            <TournamentSeriesTournamentList seriesId={series.id} />
            {isManualStandings ? (
                <TournamentSeriesStandings seriesId={series.id} />
            ) : (
                <TournamentSeriesCalculatedStandings seriesId={series.id} />
            )}
        </div>
    );
}
